import { Typography } from "@mui/material";

// Was a centered 3rem h1 on every one of this component's ~120 usages — a
// page heading, not a hero banner. h4 + start-aligned (the theme's scale,
// see src/theme/typography.ts) reads as a normal dashboard page title.
const PageTitle = ({ title }: { title: string }) => {
  return (
    <Typography variant="h4" sx={{ textAlign: "start" }}>
      {title}
    </Typography>
  );
};

export default PageTitle;
